import { render, staticRenderFns } from "./_base-nav-drop-down.vue?vue&type=template&id=1d89c1e1&scoped=true&"
import script from "./_base-nav-drop-down.vue?vue&type=script&lang=js&"
export * from "./_base-nav-drop-down.vue?vue&type=script&lang=js&"
import style0 from "./_base-nav-drop-down.vue?vue&type=style&index=0&id=1d89c1e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d89c1e1",
  null
  
)

export default component.exports